/**
 * Mobile sticky add-to-cart bar.
 * Reuses the inline PDP Add to Cart by forwarding clicks to #ProductSubmitButton-<sectionId>,
 * so the exact same product-form flow runs (cart drawer, events, variant in sync).
 * Slides up when the inline Add to Cart scrolls out of view, hides when it returns.
 */

(function () {
  function initStickyAtc(bar) {
    var sectionId = bar.dataset.sectionId;
    var realBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    var stickyBtn = bar.querySelector('[data-sticky-atc-trigger]');
    if (!realBtn || !stickyBtn) return;

    var realForm = realBtn.closest('product-form');
    var stickyLabel = stickyBtn.querySelector('.zen-sticky-atc__label');
    var stickySpinner = stickyBtn.querySelector('.loading__spinner');
    var realError = realForm && realForm.querySelector('.product-form__error-message-wrapper');
    var stickyError = bar.querySelector('.product-form__error-message-wrapper');
    var stickyErrorMsg = stickyError && stickyError.querySelector('.product-form__error-message');

    /* Mirror the inline button: label, disabled, loading state + spinner (same UX as PDP) */
    function syncButton() {
      var realLabel = realBtn.querySelector('span');
      if (stickyLabel && realLabel) stickyLabel.textContent = realLabel.textContent.trim();

      stickyBtn.disabled = realBtn.hasAttribute('disabled');
      stickyBtn.classList.toggle('loading', realBtn.classList.contains('loading'));

      if (realBtn.getAttribute('aria-disabled') === 'true') {
        stickyBtn.setAttribute('aria-disabled', 'true');
      } else {
        stickyBtn.removeAttribute('aria-disabled');
      }

      if (stickySpinner) {
        var realSpinner = realBtn.querySelector('.loading__spinner');
        stickySpinner.classList.toggle('hidden', !realSpinner || realSpinner.classList.contains('hidden'));
      }
    }

    /* Mirror the inline form error (e.g. quantity exceeds inventory) */
    function syncError() {
      if (!realError || !stickyError) return;
      stickyError.toggleAttribute('hidden', realError.hasAttribute('hidden'));
      if (stickyErrorMsg) {
        var realMsg = realError.querySelector('.product-form__error-message');
        stickyErrorMsg.textContent = realMsg ? realMsg.textContent : '';
      }
    }

    syncButton();
    syncError();

    new MutationObserver(syncButton).observe(realBtn, {
      attributes: true,
      childList: true,
      subtree: true,
    });
    if (realError) {
      new MutationObserver(syncError).observe(realError, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    /* Reuse the real Add to Cart flow exactly (same loader, validation, cart drawer) */
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled || stickyBtn.getAttribute('aria-disabled') === 'true') return;
      realBtn.click();
    });

    /* Slide up only when the inline Add to Cart is off-screen */
    new IntersectionObserver(
      function (entries) {
        var offScreen = !entries[0].isIntersecting;
        bar.classList.toggle('is-visible', offScreen);
        bar.setAttribute('aria-hidden', offScreen ? 'false' : 'true');
      },
      { threshold: 0 }
    ).observe(realBtn);
  }

  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
